module.exports = __webpack_public_path__ + "media/yolo-3.0/Dashbord-deb5e6fa.svg";